enum SidebarTabType {
    Activity = "activity",
    Comments = "comments",
    Integrations = "integrations",
}

export default SidebarTabType;
